import React, { useEffect } from 'react';
import { data } from 'azure-maps-control';
import AzureMapBase from 'components/maps/azure/AzureMapBase';
import AzureMapMarker from 'components/maps/azure/AzureMapMarker';
import AzureMapPopup from 'components/maps/azure/AzureMapPopup';
import { useTranslation } from "react-i18next";

// Ajusta la cámara Azure según los waypoints o el centro proporcionado.
const AzureCenter = ({ map, waypoints = [], centerProp }) => {
    useEffect(() => {
        if (!map) return;

        const entries = (waypoints || []).map(w => [parseFloat(w.lng), parseFloat(w.lat)]);

        if (entries.length === 1) {
            const [lng, lat] = entries[0];
            map.setCamera({ center: [lng, lat], zoom: 13, type: 'ease' });
            return;
        }

        if (entries.length > 1) {
            const bbox = data.BoundingBox.fromPositions(entries);
            map.setCamera({ bounds: bbox, padding: 60, type: 'ease' });
            return;
        }

        // fallback: usar centerProp si no hay waypoints
        if (Array.isArray(centerProp) && centerProp.length >= 2) {
            const lat = parseFloat(centerProp[0]);
            const lng = parseFloat(centerProp[1]);
            map.setCamera({ center: [lng, lat], zoom: 13, type: 'ease' });
        }
    }, [map, JSON.stringify(waypoints), JSON.stringify(centerProp)]);

    return null;
};

const AzureMapAssetsContainer = ({ center, waypoints = [] }) => {
    const { t: _Tc } = useTranslation("choices");
    const ZOOM = 13;

    return (
        <AzureMapBase
            center={center}
            zoom={ZOOM}
            height="300px"
        >
            <AzureCenter waypoints={waypoints} centerProp={center} />
            {waypoints.map((waypoint, idx) => (
                <AzureMapMarker
                    key={idx}
                    position={[waypoint.lat, waypoint.lng]}
                    options={{
                        color: '#49cb5c'
                    }}
                >
                    <AzureMapPopup>
                        <div className="bg-white p-2 rounded shadow-sm">
                            {_Tc("wastes." + waypoint.waste_type)}
                        </div>
                    </AzureMapPopup>
                </AzureMapMarker>
            ))}
        </AzureMapBase>
    );
};

export default AzureMapAssetsContainer;
